import { IconButton } from '@chakra-ui/react';
import React from 'react';
import ArrowIcon, { ArrowIconDirection } from '../../icons/ArrowIcon';
const BackButton = (props) => {
    const style = { w: '56px', h: '48px' };
    return (React.createElement(IconButton, { data: true, sx: style, variant: "white-grey", "aria-label": "Back button", "data-testid": "back_button", icon: React.createElement(ArrowIcon, { orientation: ArrowIconDirection.LEFT }), ...props }));
};
export default BackButton;
